import { Link } from 'react-router-dom';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 flex items-center">
        <section className="w-full px-4 md:px-6 lg:px-10 py-24 md:py-32 bg-background-50">
          <div className="flex flex-col items-center text-center">
            <span className="font-heading text-6xl md:text-8xl font-black text-primary-200 select-none">404</span>
            <h1 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              这个页面走丢了
            </h1>
            <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
              你访问的页面可能已经调整过地址。可以回到首页，从分类导航重新找一个方向。
            </p>
            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <Link
                to="/"
                className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 font-label text-sm whitespace-nowrap hover:bg-primary-600 transition-colors"
              >
                <i className="ri-home-4-line" aria-hidden="true"></i>
                返回首页
              </Link>
              <Link
                to="/#categories"
                className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md border border-background-300 bg-background-50 font-label text-sm whitespace-nowrap text-foreground-800 hover:border-primary-400 hover:text-primary-600 transition-colors"
              >
                <i className="ri-layout-grid-line" aria-hidden="true"></i>
                浏览分类导航
              </Link>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}